<template>
  <div class="container-fluid w-100">
    <div class="row no-gutters w-100">
      <div class="col-lg-12">
        <div class="card">
          <div class="hori-timeline" dir="ltr">
            <ul class="row no-gutters list-inline events">
              <li
                class="col list-inline-item event-list"
                v-for="(time, flux, index) in chapter"
                :key="flux"
                :style="`width:${
                  100 / chapter.length
                }% !important,background-color: white;`"
              >
                <div class="px-4">
                  <div
                    @click="setEndpoint(chapter[flux])"
                    v-if="index == chapter_reading && $store.getters.isPlaying"
                    class="event-date text-white"
                    style="background-color: #ff9800; cursor: pointer"
                    href="javascript:;"
                  >
                    {{ index + 1 }}
                  </div>
                  <div
                    v-else
                    @click="setEndpoint(chapter[flux])"
                    class="event-date bg-soft-white text-primary"
                    style="cursor: pointer"
                  >
                    {{ index + 1 }}
                  </div>
                  <p class="text-muted">
                    {{ flux }}
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <!-- end card -->
      </div>
    </div>
  </div>
</template>

<script>
//  import componentMixin from "ireal-vue/mixins/component-mixin.js";
import inputComponentMixin from "ireal-vue/mixins/input-component-mixin.js";
import ComponentMixin from "ireal-vue/mixins/component-mixin.js";
import httpService from "../services/http-service";
import Bus from "../services/bus.js";

export default {
  name: "timeline-input-component",
  mixins: [httpService, ComponentMixin, inputComponentMixin],
  components: {},
  data() {
    return {
      chapter_reading: 0,
      chapter: [],
      tab_chapter_time: [],
      controle: undefined,
    };
  },
  async created() {
    this.definitions = this.config.elements;
    Bus.$on("ireal-start", async () => {
      this.controle = setInterval(() => {
        this.$store.getters.duration > 0 ? this.consult() : "";
      }, 100);
    });
  },
  computed: {},
  methods: {
    prepare() {},
    setEndpoint(time) {
      // get the time of the player to position and send the action to the store
      console.log(time);
      this.endpoint(time);
    },
    consult() {
      clearInterval(this.controle);
      const start = 0;
      const end = this.$store.getters.duration;
      let flux_identifier = this.attributes.name;
      let params = {
        params: this.$store.getters.testParams,
        start,
        end,
        flux_identifier,
        experience_id: this.$store.getters.experience.id,
        seed: this.$store.getters.seed,
      };
      // retrieves the JSON object that contains the list of steps and the timecode
      this.getObjectList("observation_data/by_params", params).then((data) => {
        this.tab_chapter_time = [];
        this.chapter = JSON.parse(data[0].raw_value);
        for (var step in this.chapter) {
          this.tab_chapter_time.push(this.chapter[step]);
        }
        return data;
      });
    },
    tick() {
      if (this.$store.getters.progress > 1) {
        //find the first element of the timecode list that is higher than the player progression
        const found = this.tab_chapter_time.find(
          (element) => element > this.$store.getters.progress
        );
        // indicate which step number is currently playing
        found
          ? (this.chapter_reading = this.tab_chapter_time.indexOf(found) - 1)
          : (this.chapter_reading = this.tab_chapter_time.length - 1);
      }
    },
  },
};
</script>
<style scoped>
body {
  background: #eee;
  margin-top: 20px;
}
p {
  font-size: 0.775em;
}

@media screen and (max-width: 64em) {
  h1 {
    font-size: 0.8em;
  }
}

@media screen and (max-width: 50em) {
  p {
    font-size: 0.7em;
  }
}

@media screen and (max-width: 30em) {
  p {
    font-size: 0.6em;
  }
}
.hori-timeline .events {
  border-top: 3px solid #e9ecef;
}
.hori-timeline .events .event-list {
  display: block;
  position: relative;
  text-align: center;
  padding-top: 70px;
  margin-right: 0;
}
.hori-timeline .events .event-list:before {
  content: "";
  position: absolute;
  height: 36px;
  border-right: 2px dashed #dee2e6;
  top: 0;
}
.hori-timeline .events .event-list .event-date {
  position: absolute;
  top: 38px;
  left: 0;
  right: 0;
  width: 75px;
  margin: 0 auto;
  border-radius: 4px;
  padding: 2px 4px;
}
@media (min-width: 1140px) {
  .hori-timeline .events .event-list {
    display: inline-block;
    width: 24%;
    padding-top: 45px;
  }
  .hori-timeline .events .event-list .event-date {
    top: -12px;
  }
}
.bg-soft-primary {
  background-color: rgba(64, 144, 203, 0.3) !important;
}
.bg-soft-success {
  background-color: rgba(71, 189, 154, 0.3) !important;
}
.bg-soft-danger {
  background-color: rgba(231, 76, 94, 0.3) !important;
}
.bg-soft-warning {
  background-color: rgba(249, 213, 112, 0.3) !important;
}
.card {
  border: none;
  margin-bottom: 24px;
  -webkit-box-shadow: 0 0 13px 0 rgba(236, 236, 241, 0.44);
  box-shadow: 0 0 13px 0 rgba(236, 236, 241, 0.44);
}
</style>
